import sanitizeHtml from "sanitize-html";

/**
 * Sanitize HTML for safe display. Prevents XSS from merchant/user-provided content.
 * - No script, img, svg, iframe, object, embed
 * - No event handlers (onerror, onclick, etc.)
 * - Links restricted to http, https, mailto
 */
export function sanitize(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: ["p", "br", "strong", "em", "b", "i", "a", "div", "span", "ul", "ol", "li"],
    allowedAttributes: { a: ["href"] },
    allowedSchemes: ["http", "https", "mailto"],
    allowedSchemesByTag: { a: ["http", "https", "mailto"] },
  });
}
